import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"braces"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.00039 20H5.90039C4.57491 20 3.50039 18.9255 3.50039 17.6V14C3.50039 12.8954 2.60496 12 1.50039 12M1.50039 12H1.40039M1.50039 12C2.60496 12 3.50039 11.1046 3.50039 10V6.4C3.50039 5.07452 4.57491 4 5.90039 4H6.00039M17.9995 20H18.0995C19.425 20 20.4995 18.9255 20.4995 17.6V14C20.4995 12.8954 21.3949 12 22.4995 12M22.4995 12H22.5995M22.4995 12C21.3949 12 20.4995 11.1046 20.4995 10V6.4C20.4995 5.07452 19.425 4 18.0995 4H17.9995","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Braces = Vue.extend<IconProps>({
  name: 'BracesIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'braces',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Braces;
